import { render, staticRenderFns } from "./gift-dialog.vue?vue&type=template&id=8b974e98&scoped=true&"
import script from "./gift-dialog.vue?vue&type=script&lang=js&"
export * from "./gift-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b974e98",
  null
  
)

export default component.exports